import axios, { STRAPI_URL } from '@propertypal/shared/src/services/axios.strapi';
import { IPropertyPalTerm, IPropertyNewsTerm } from '@propertypal/shared/src/types/strapi';
import { StrapiResponse } from '@propertypal/shared/src/types/strapi/generic';
import platform from '@propertypal/shared/src/utils/platform';
import PolicyContent from '@propertypal/web-ui/src/policy-content/PolicyContent';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../components/layout/MetaTags';

interface TermsPageProps {
  data: IPropertyPalTerm | IPropertyNewsTerm | null;
}

export const getStaticProps: GetStaticProps<TermsPageProps> = async () => {
  const result = await axios<StrapiResponse<IPropertyPalTerm | IPropertyNewsTerm>>({
    method: 'GET',
    url: `${STRAPI_URL}/property-${platform.select('pal', 'news')}-term`,
    params: { populate: 'deep' },
  });

  return {
    props: {
      data: result.data.data,
    },
  };
};

const TermsPage: React.FC<TermsPageProps> = ({ data }) => {
  return (
    <>
      <Head>
        {generateMetaTags({
          title: `Terms & Conditions - ${platform.title}`,
          url: '/terms',
        })}
      </Head>

      {data?.attributes && <PolicyContent {...data?.attributes} />}
    </>
  );
};

export default TermsPage;
